"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
var _taskConfig = require("@/api/taskConfig/taskConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserTaskStatusList',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        startTime: '',
        endTime: '',
        taskTitle: '',
        cardNo: '',
        mobile: '',
        // ✅ 新增字段
        status: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      statusMap: {
        todo: '待完成',
        ready: '可领取',
        done: '已领取',
        loading: '领取中'
      },
      dialogTableVisible: false,
      gridData: []
    };
  },
  methods: {
    formatTimestamp: function formatTimestamp(ts) {
      if (!ts) return '-';
      var time = Number(ts);
      if (isNaN(time)) return '-';
      var date = new Date(time);
      return date.toLocaleString();
    },
    handleOptEdit: function handleOptEdit(row) {
      var _this = this;
      this.loading = true;
      this.$confirm('确定此任务状态更改为“可领取”?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _taskConfig.optStatus)(row).then(function (res) {
          _this.$message.success('操作成功');
          _this.fetchList();
        }).catch(function (err) {
          _this.$message.error('操作失败');
        }).finally(function () {
          _this.loading = false;
        });
      }).catch(function () {
        _this.$message.info('已取消');
        _this.loading = false; //
      });
    },
    formatTime: function formatTime(ts) {
      if (!ts) return '-';
      var date = new Date(Number(ts) * 1000);
      var Y = date.getFullYear();
      var M = String(date.getMonth() + 1).padStart(2, '0');
      var D = String(date.getDate()).padStart(2, '0');
      var h = String(date.getHours()).padStart(2, '0');
      var m = String(date.getMinutes()).padStart(2, '0');
      var s = String(date.getSeconds()).padStart(2, '0');
      return "".concat(Y, "-").concat(M, "-").concat(D, " ").concat(h, ":").concat(m, ":").concat(s);
    },
    // 是否同一天
    isSameDay: function isSameDay(payTime, receiveTime) {
      if (!payTime || !receiveTime) return true;
      var d1 = new Date(payTime * 1000);
      var d2 = new Date(receiveTime * 1000);
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    },
    openDia: function openDia(row) {
      this.gridData = row.orderItem || []; // ✅ 兜底，防止 undefined
      this.dialogTableVisible = true;
    },
    fetchList: function fetchList() {
      var _this2 = this;
      // if(!this.searchForm.mobile&&!this.searchForm.cardNo){
      //   this.$message.warning('手机号或卡号必须输入一项！')
      //   return false;
      // }
      this.loading = true;
      (0, _taskConfig.pageErr)(this.searchForm).then(function (res) {
        _this2.tableData = res.data || [];
      }).finally(function () {
        _this2.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        taskTitle: '',
        cardNo: '',
        mobile: '',
        // ✅ 重置手机号
        status: '',
        page: 1,
        limit: 10,
        total: 0
      };
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    }
  },
  mounted: function mounted() {
    // this.fetchList()
  }
};